var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52184_117088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.889323 10H11.556C11.9227 10 12.2227 9.7 12.2227 9.33333C12.2227 8.96667 11.9227 8.66667 11.556 8.66667H0.889323C0.522656 8.66667 0.222656 8.96667 0.222656 9.33333C0.222656 9.7 0.522656 10 0.889323 10ZM0.889323 6.66667H11.556C11.9227 6.66667 12.2227 6.36667 12.2227 6C12.2227 5.63333 11.9227 5.33333 11.556 5.33333H0.889323C0.522656 5.33333 0.222656 5.63333 0.222656 6C0.222656 6.36667 0.522656 6.66667 0.889323 6.66667ZM0.222656 2.66667C0.222656 3.03333 0.522656 3.33333 0.889323 3.33333H11.556C11.9227 3.33333 12.2227 3.03333 12.2227 2.66667C12.2227 2.3 11.9227 2 11.556 2H0.889323C0.522656 2 0.222656 2.3 0.222656 2.66667Z",
    fill: "#979797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52184_117088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.222656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerDark);
export default __webpack_public_path__ + "static/media/hamburger_dark.7962f8c22b84cb3e4488f0c77c6d10fe.svg";
export { ForwardRef as ReactComponent };